export default "__VITE_ASSET__f4b6f8e6__"